/**
 * Immutably adds a value inside an object or an array given a path.
 * The path is created inside the object is not exists.
 * @param obj The object or array
 * @param path The path within the object or array where the value should enter
 * @param value The value that should go inside the path
 */
export function immutablyChangeValue(obj: any | any[], path: (string | number)[], value: any): any {
  if (!path.length) {
    return value;
  }

  const part = path.shift() as string | number;

  if (typeof part === "number" && (Array.isArray(obj) || !obj)) {
    obj = obj || [];
    return [...obj.slice(0, part), immutablyChangeValue(obj[part], path, value), ...obj.slice(part + 1, obj.length)];
  } else if (!obj || (typeof obj === "object" && !Array.isArray(obj))) {
    obj = obj || {};
    return {
      ...obj,
      [part]: immutablyChangeValue(obj[part], path, value)
    };
  } else {
    throw new Error("path is wrong!");
  }
}

/**
 * Immutably deletes a value inside an object or an array given a path.
 * @param obj The object or array
 * @param path The path of the value within the object or array that should be removed
 */
export function immutablyRemoveValue(obj: any | any[], path: (string | number)[]): any {
  if (!path.length) {
    return;
  }
  if (path.length === 1) {
    const part = path[0];
    if (typeof part === "number" && Array.isArray(obj)) {
      return [...obj.slice(0, part), ...obj.slice(part + 1, obj.length)];
    } else if (typeof obj === "object" && !Array.isArray(obj)) {
      const newObj = { ...obj };
      delete newObj[part];
      return newObj;
    } else {
      throw new Error("path is wrong!");
    }
  }

  const part = path.shift() as string | number;

  if (typeof part === "number" && Array.isArray(obj)) {
    return [...obj.slice(0, part), immutablyRemoveValue(obj[part] || {}, path), ...obj.slice(part + 1, obj.length)];
  } else if (typeof obj === "object" && !Array.isArray(obj)) {
    return {
      ...obj,
      [part]: immutablyRemoveValue(obj[part] || {}, path)
    };
  } else {
    throw new Error("path is wrong!");
  }
}
